import { render, staticRenderFns } from "./outboundSms.vue?vue&type=template&id=4b11c478"
import script from "./outboundSms.vue?vue&type=script&lang=js"
export * from "./outboundSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports